function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function safeUrl(u) {
  try {
    const url = new URL(u, window.location.origin);
    return (/^https?:$/i).test(url.protocol) ? url.href : '#';
  } catch {
    return '#';
  }
}

// Very small Markdown -> HTML; escapes HTML first
export function mdToHtml(md) {
  if (!md) return '';
  let s = escapeHtml(md);

  // Convert GitHub-style tables before other line transforms
  s = (function convertTables(input) {
    const lines = input.split(/\r?\n/);
    let out = [];
    for (let i = 0; i < lines.length; i++) {
      const l = lines[i];
      const mHead = /^\s*\|(.+)\|\s*$/.exec(l);
      const l2 = i + 1 < lines.length ? lines[i + 1] : '';
      const isSep = /^\s*\|?\s*(:?-{3,}:?\s*\|\s*)+(:?-{3,}:?)\s*\|?\s*$/.test(l2);
      if (mHead && isSep) {
        // Parse header
        const headerCells = mHead[1].split('|').map(c => c.trim());
        i++; // skip separator line
        let bodyRows = [];
        while (i + 1 < lines.length) {
          const nx = lines[i + 1];
          if (!/^\s*\|(.+)\|\s*$/.test(nx)) break;
          i++;
          const rowMatch = /^\s*\|(.+)\|\s*$/.exec(nx);
          const cells = rowMatch[1].split('|').map(c => c.trim());
          bodyRows.push(cells);
        }
        // Build bootstrap table
        let html = '<div class="table-responsive libby-table-wrap"><table class="table table-sm table-striped table-bordered mb-0">';
        html += '<thead><tr>' + headerCells.map(h => `<th>${h}</th>`).join('') + '</tr></thead>';
        html += '<tbody>' + bodyRows.map(r => '<tr>' + r.map(c => `<td>${c}</td>`).join('') + '</tr>').join('') + '</tbody>';
        html += '</table></div>';
        out.push(html);
      } else {
        out.push(l);
      }
    }
    return out.join('\n');
  })(s);

  s = (function convertUnorderedLists(input) {
    const lines = input.split(/\r?\n/);
    let out = [];
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      const bullet = /^\s*-\s+(.+)\s*$/.exec(line);
      if (!bullet) {
        out.push(line);
        continue;
      }

      let items = [bullet[1].trim()];
      while (i + 1 < lines.length) {
        const nextLine = lines[i + 1];
        const nextBullet = /^\s*-\s+(.+)\s*$/.exec(nextLine);
        if (!nextBullet) break;
        i++;
        items.push(nextBullet[1].trim());
      }

      const html = '<ul class="libby-list">' + items.map(item => `<li>${item}</li>`).join('') + '</ul>';
      out.push(html);
    }
    return out.join('\n');
  })(s);

  // ATX headings (#, ##, ###) → h1/h2/h3
  s = s.replace(/^###\s+(.+)$/gm, '<h3>$1</h3>');
  s = s.replace(/^##\s+(.+)$/gm, '<h2>$1</h2>');
  s = s.replace(/^#\s+(.+)$/gm, '<h1>$1</h1>');
  // code fences ```
  s = s.replace(/```([\s\S]*?)```/g, (m, p1) => `<pre><code>${p1}</code></pre>`);
  // inline code
  s = s.replace(/`([^`]+)`/g, (m, p1) => `<code>${p1}</code>`);
  // links [text](url)
  s = s.replace(/\[([^\]]+)\]\(([^\)\s]+)\)/g, (m, t, u) => `<a href="${safeUrl(u)}" target="_blank" rel="noopener noreferrer">${t}</a>`);
  // bold **text** first
  s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  // italics *text*
  s = s.replace(/(^|\W)\*([^*]+)\*(?=\W|$)/g, '$1<em>$2</em>');
  // line breaks
  s = s.replace(/\r?\n/g, '<br>');
  s = s.replace(/<br>\s*(<ul class="libby-list">)/g, '$1');
  s = s.replace(/(<\/ul>)\s*<br>/g, '$1');
  return s;
}
